<template>
  <div class="ui segment">
    <div class="centered-header">
      <h2 class="ui header" style="color: #092442;">
        <i class="clipboard outline icon"></i>
        <div class="content">
          Packages
        </div>
      </h2>
    </div>
    <div class="ui divider"></div>
    <table class="ui celled table">
      <thead>
        <tr>
          <th> Name </th>
          <th> Quantity </th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="selectedPackage in packages">
          <td> {{ selectedPackage.name }} </td>
          <td>
            <div class="ui fluid transparent input">
              <input type="number"
                     :placeholder="'Package Quantity'"
                     v-model="selectedPackage.NumberRepeatedTimes">
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  props: {
    packages: { type: Array, required: true }
  },
  data () {
    return {

    }
  },
  computed: {
  },
  methods: {
    next () {
      this.$emit('reservation-reservationStepChanges', {
        data: {
          reservationInfo: this.reservation,
          fullSelectedPackages: this.reservationPackages(),
          next: $('#reservation-info-step').form('is valid')
        }
      })
    },
    perivous () {
      this.$emit('reservation-goBack')
    }
  }
}
</script>

<style scoped>
  .centered-header {
    display: flex;
    justify-content: center;
  }
</style>



// WEBPACK FOOTER //
// src/components/steps/reservations/new_reservations_steps/NewPackagesStep.vue